import { ConflictMineralStatus } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';
import { StatusChip } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import React from 'react';

import { ConflictMineralStatusTranslations } from '../../i18n';

export const ConflictMineralStatusChip: React.FunctionComponent<{
    status: ConflictMineralStatus;
}> = ({ status }) => {
    const label = transEnum(status, ConflictMineralStatusTranslations);
    switch (status) {
        case ConflictMineralStatus.Compliant:
            return <StatusChip color="green" label={label} />;
        case ConflictMineralStatus.Unknown:
            return <StatusChip color="neutral" label={label} />;
        default:
            assertUnreachable(status);
    }
};
